import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import { NotAuthorized } from 'app/components/not-authorized';
import { CardContainer } from 'app/components/shared/card-container';
import AddFareMediaType from 'app/configuration/fare-media-types/addFareMediaType';
import FareMediaTypesTable from 'app/configuration/fare-media-types/FareMediaTypesTable';
import UpdateFareMediaType from 'app/configuration/fare-media-types/updateFareMediaType';
import ViewFareMediaType from 'app/configuration/fare-media-types/view-FareMediaType';
import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasWriteAccessToFareMediaTypes } from 'selectors';

const FareMediaTypes: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);

  const hasWriteAccess = useTypedSelector(hasWriteAccessToFareMediaTypes);

  return (
    <CardContainer>
      <Switch>
        <Route path={`${baseURL}/new`}>
          {hasWriteAccess ? <AddFareMediaType /> : <NotAuthorized />}
        </Route>

        <Route path={`${baseURL}/:id/edit`}>
          {hasWriteAccess ? <UpdateFareMediaType /> : <NotAuthorized />}
        </Route>

        <Route path={`${baseURL}/:id`}>
          <ViewFareMediaType />
        </Route>

        <Route exact path={`${baseURL}`}>
          <FareMediaTypesTable />
        </Route>
      </Switch>
    </CardContainer>
  );
};

export { FareMediaTypes };
